import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {SupplierDeliveryRecordList} from '../../modules/supplier-delivery-record/SupplierDeliveryRecordList'

const SupplierDeliveryRecordPage: FC = () => {
  const {formatMessage} = useIntl()

  return (
    <>
      <PageTitle>{formatMessage({id: 'MENU.SUPPLIER_DELIVERY_RECORD'})}</PageTitle>
      <SupplierDeliveryRecordList />
    </>
  )
}

export default SupplierDeliveryRecordPage
